import React from 'react'
import { SelectedChip } from '../SelectedChip/SelectedChip'
import { ChipProps } from '@mui/material'
import DoneIcon from '@mui/icons-material/Done'

interface Props extends ChipProps {
  filterInput: boolean
  setFilterInput: (newFilter: boolean) => void
}

export const BooleanFilter: React.FC<React.PropsWithChildren<Props>> = ({
  filterInput,
  setFilterInput,
  ...chipProps
}) => {
  return (
    <SelectedChip
      selected={filterInput}
      onClick={() => setFilterInput(!filterInput)}
      icon={filterInput ? <DoneIcon /> : undefined}
      {...chipProps}
    />
  )
}
